import React, { useState } from 'react';
import { AppHeader } from '../../../components/AppHeader/AppHeader';
import { useShellNav } from '../../../access/useShellNav';
import {
  Button,
  Icon,
  Input,
  MenuLeaf,
  Modal,
  PageHeading,
  Section,
  Sidebar,
  Submenu,
  Text,
} from 'barte-design-system';
import {
  Flag,
  Lightning,
  Percent,
  FileText,
  Receipt,
  UsersThree,
} from '@phosphor-icons/react';
import { SellerTagInput, SELLERS_VINCULADOS } from './SellerTagInput';
import './PlanoTaxas.css';

// ─── Component ────────────────────────────────────────────────────────────────

interface CadastrarPlanoProps {
  onBack: () => void;
}

export function CadastrarPlano({ onBack }: CadastrarPlanoProps) {
  const { sidebarProps } = useShellNav();
  const [nomePlano, setNomePlano] = useState('');
  const [sellers, setSellers] = useState<string[]>([]);
  const [modalConfirmacao, setModalConfirmacao] = useState(false);

  const sellersEmConflito = sellers.filter((s) => !!SELLERS_VINCULADOS[s]);

  function handleSalvar() {
    if (sellersEmConflito.length > 0) {
      setModalConfirmacao(true);
    } else {
      onBack();
    }
  }

  return (
    <div className="app-layout">
      <AppHeader variant="payfac" avatarProps={{ variant: 'icon' }} />

      <div className="app-body">
        <Sidebar {...sidebarProps}>
          <MenuLeaf
            label="Dashboard"
            icon={<Icon icon={Lightning} size={20} weight="regular" />}
          />
          <MenuLeaf
            label="Vendedores"
            icon={<Icon icon={UsersThree} size={20} weight="regular" />}
          />
          <MenuLeaf
            label="Transações"
            icon={<Icon icon={Receipt} size={20} weight="regular" />}
          />
          <MenuLeaf
            label="Contestações"
            icon={<Icon icon={Flag} size={20} weight="regular" />}
          />
          <MenuLeaf
            label="Taxas"
            icon={<Icon icon={Percent} size={20} weight="regular" />}
            isOpen
          >
            <Submenu label="Plano de Taxas" isActive />
            <Submenu label="Parceiros" />
            <Submenu label="Negociações" />
          </MenuLeaf>
          <MenuLeaf
            label="Relatórios"
            icon={<Icon icon={FileText} size={20} weight="regular" />}
          />
        </Sidebar>

        <main className="content">
          <div className="content-inner">
            <PageHeading
              title="Cadastrar Novo Plano de Taxas"
              onBack={onBack}
              primaryActionLabel="Salvar"
              onPrimaryAction={handleSalvar}
            />

            <Input
              label="Nome do plano"
              placeholder="Digite o nome do plano"
              value={nomePlano}
              onChange={(e) => setNomePlano((e.target as HTMLInputElement).value)}
            />

            <SellerTagInput onSellersChange={setSellers} />

            {/* ── Pix ─────────────────────────────────────────────────── */}
            <Section
              title="Pix"
              variant="two-columns"
              headerActions={
                <Button variant="ghost" size="sm" onClick={() => {}}>Editar</Button>
              }
              secondColumn={
                <>
                  <Section.Row label="Tipo de taxa" content={<Text variant="label-sm">Porcentagem</Text>} />
                  <Section.Row label="Limite de taxas" content="-" />
                </>
              }
            >
              <Section.Row label="Tempo de repasse" content="-" />
              <Section.Row label="Total Cobrado" content="-" />
            </Section>

            {/* ── Boleto ──────────────────────────────────────────────── */}
            <Section
              title="Boleto"
              variant="two-columns"
              headerActions={
                <Button variant="ghost" size="sm" onClick={() => {}}>Editar</Button>
              }
              secondColumn={
                <>
                  <Section.Row label="Tipo de taxa" content={<Text variant="label-sm">Porcentagem</Text>} />
                  <Section.Row label="Total Cobrado" content="-" />
                </>
              }
            >
              <Section.Row label="Tempo de repasse" content="-" />
              <Section.Row label="Markup" content={<Text variant="label-sm">0,00%</Text>} />
              <Section.Row label="Limite de taxas" content="-" />
            </Section>

            {/* ── Cartão de Débito ─────────────────────────────────────── */}
            <Section
              title="Cartão de Débito"
              variant="two-columns"
              headerActions={
                <Button variant="ghost" size="sm" onClick={() => {}}>Editar</Button>
              }
              secondColumn={
                <>
                  <Section.Row label="Tipo de taxa" content={<Text variant="label-sm">Porcentagem</Text>} />
                  <Section.Row label="Taxa Barte" content={<Text variant="label-sm">0,00%</Text>} />
                </>
              }
            >
              <Section.Row label="Tempo de repasse" content="-" />
              <Section.Row label="Markup" content="-" />
              <Section.Row label="Total Cobrado" content={<Text variant="label-sm">0,00%</Text>} />
            </Section>

            {/* ── Cartão de Crédito ────────────────────────────────────── */}
            <Section
              title="Cartão de Crédito"
              variant="two-columns"
              headerActions={
                <Button variant="ghost" size="sm" onClick={() => {}}>Editar</Button>
              }
              secondColumn={
                <>
                  <Section.Row label="Tipo de taxa" content={<Text variant="label-sm">Porcentagem</Text>} />
                  <Section.Row label="Taxa Barte" content={<Text variant="label-sm">0,00%</Text>} />
                </>
              }
            >
              <Section.Row label="Tempo de repasse" content="-" />
              <Section.Row label="Markup" content="-" />
              <Section.Row label="Total Cobrado" content={<Text variant="label-sm">0,00%</Text>} />
            </Section>

          </div>
        </main>
      </div>

      <Modal
        isOpen={modalConfirmacao}
        title="Confirmar alteração de plano"
        onClose={() => setModalConfirmacao(false)}
        footer={{
          primaryButton: {
            children: 'Confirmar',
            onClick: () => { setModalConfirmacao(false); onBack(); },
          },
          secondaryButton: {
            children: 'Cancelar',
            onClick: () => setModalConfirmacao(false),
          },
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Text variant="body-sm">Seller que está mudando de plano de taxas vinculado:</Text>
          {sellersEmConflito.map((s) => (
            <Text key={s} variant="label-sm">{s}</Text>
          ))}
        </div>
      </Modal>
    </div>
  );
}
